import Box from "ds/components/Box";
import ComboBoxHighlightText from "ds/components/ComboBox/HighlightText";
import ListBoxItem from "ds/components/ListBox/Item";
import CheckboxIcon from "ds/components/Toggle/CheckboxIcon";

type ComboBoxMultipleDefaultItemProps = {
  id: string;
  label: string;
  isSelected?: boolean;
  checkboxVisible?: boolean;
};

const ComboBoxMultipleDefaultItem = ({
  id,
  label,
  isSelected,
  checkboxVisible,
}: ComboBoxMultipleDefaultItemProps) => (
  <ListBoxItem id={id} textValue={label} aria-describedby={`${id}-description`}>
    <Box gap="medium">
      {checkboxVisible && <CheckboxIcon isSelected={isSelected} />}
      <Box direction="column" gap="small" justify="center" align="start" fullWidth>
        <ComboBoxHighlightText text={label} />
      </Box>
    </Box>
  </ListBoxItem>
);

export default ComboBoxMultipleDefaultItem;
